import React from "react";
import "./LanguageItem.scss";
import Image from "../Image/Image";

interface PT {
  value: string;
  label: string;
}

const LanguageItem: React.FC<PT> = ({ value, label }) => {
  return (
    <div className="language-item">
      <Image className={`language-item-flag language-${value}`} />
      {label}
    </div>
  );
};

export default React.memo(LanguageItem);
